import React, { forwardRef } from 'react';
import { cn } from './cn';

/** Native range behavior with the shared focus ring and a 44px touch target. */
const Slider = forwardRef(function Slider({ className, ...props }, ref) {
  return <input
    {...props}
    ref={ref}
    type="range"
    className={cn(
      'block h-11 w-full cursor-pointer appearance-none bg-transparent accent-bun-ink',
      'focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bun-blue',
      '[&::-webkit-slider-runnable-track]:h-1 [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-bun-line-strong',
      '[&::-webkit-slider-thumb]:-mt-1.5 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-solid [&::-webkit-slider-thumb]:border-bun-ink [&::-webkit-slider-thumb]:bg-bun-surface',
      '[&::-moz-range-track]:h-1 [&::-moz-range-track]:rounded-full [&::-moz-range-track]:bg-bun-line-strong',
      '[&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-solid [&::-moz-range-thumb]:border-bun-ink [&::-moz-range-thumb]:bg-bun-surface',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
  />;
});

export default Slider;
